export const reviewsKeys = {
    list: (subdomain, options) => options ? ['reviews', subdomain, options] : ['reviews', subdomain],
    claim: (subdomain, id) => ['reviews', subdomain, id],
    events: (subdomain, id) => ['reviews', subdomain, id, 'events'],
    alerts: (subdomain, id) => ['reviews', subdomain, id, 'alerts'],
    userStats: (subdomain, id) => ['reviews', subdomain, id, 'userStats'],
    comments: (subdomain, questId) => ['reviews', subdomain, 'comments', questId],
    pendingCount: (subdomain) => ['reviews', subdomain, 'pendingCount'],
};
